import axios from 'axios'

import { config, keys,platform_name } from "../../../config.env";
import { getStorage } from '../../../lib'

const ENDPOINT_DOMAIN = config.API_ENDPOINT
const MICROSERVICE_TOKEN = config.API_TOKEN

const baseUrl = ENDPOINT_DOMAIN + "/api/v1"

export const ApiFindDropdownList = (params) => {
	return new Promise((resolve) => {
		const config = {
			method: "get",
			params: params,
			url: baseUrl + `/data/findDropdownList`,
			headers: {
				platform: "mod-healthsystem-microservice",
				Authorization: `Bearer ${MICROSERVICE_TOKEN}`,
			},

		}
		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}

export const ApiFindCheckList = (params) => {
	return new Promise((resolve) => {
		const config = {
			method: "get",
			params: params,
			url: baseUrl + `/data/findChecklist`,
			headers: {
				platform: "mod-healthsystem-microservice",
				Authorization: `Bearer ${MICROSERVICE_TOKEN}`,
			},

		}
		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}


export const ApiFindHospital = (params) => {
	return new Promise((resolve) => {
		const config = {
			method: "get",
			params: params,
			url: baseUrl + `/data/findHospital`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}
		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}

export const ApiFindDepartment = (params) => {
	return new Promise((resolve) => {
		const config = {
			method: "get",
			params: params,
			url: baseUrl + `/data/findDepartment`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}
		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}
export const ApiFindDocument = (params) => {
	return new Promise((resolve) => {
		const config = {
			method: "get",
			params: params,
			url: baseUrl + `/microservice/findDocument`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}
		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})

}



export const ApiFindOverview = (params) => {
	return new Promise((resolve) => {
		const config = {
			method: "get",
			params: params,
			url: baseUrl + `/analytics/summary/dashboard/yearly-comparison-overview`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}
		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})

}

export const ApiFindMyHealthHistory = (params) => {

	return new Promise((resolve) => {
		const config = {
			method: "get",
			params: params,
			url: baseUrl + `/analytics/summary/myHealth/history`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
			},

		}
		axios(config)
			.then((res) => {
				if (res.data.status) {
					resolve(res.data)
				} else {
					resolve(false)
				}
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})

}

export const ApiUploadExcel = (hospital_code, file) => {
	return new Promise((resolve) => {

		const formData = new FormData();
		formData.append('excel', file);
		formData.append('hospital_code', hospital_code);
		const config = {
			method: "post",
			data: formData,
			url: baseUrl + `/upload/excel/import-health-data-v.1.0.0`,
			headers: {
				platform: platform_name,
				Authorization: `Bearer ${getStorage(keys.access_token)}`,
				'Content-Type': 'multipart/form-data',
			},

		}


		axios(config)
			.then((res) => {
				resolve(res.data)
			})
			.catch((err) => {
				console.log("Err", err)
				resolve(false)
			})
	})
}


